module.exports = "<div ng-message=\"required\" translate>This field is required.</div>\n<div ng-message=\"minlength\" translate>Your field is too short</div>\n<div ng-message=\"maxlength\" translate>Your field is too long</div>\n<div ng-message=\"email\" translate>You must supply a valid email address.</div>";


//////////////////
// WEBPACK FOOTER
// ./src/sharebase/components/defaultErrorMessages/errorMessages.template.html
// module id = 1071
// module chunks = 0